<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item>
          <el-button v-if="showAllRecordBtn" type="primary" @click="goPaymentRecord">打款记录</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="printSelected">选择打印</el-button>
        </el-form-item>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`全部打款记录列表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      :showTotal="true" :getTotal="getTotal" :btns="btns" :showSelect="true" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template #moneydetail="params">
        <span>{{ params.params.money }}</span>&nbsp;
        <el-button class="btn" type="primary" @click="showMoneyDetail(params.params)" size="mini">
          费用详情
        </el-button>
      </template>
      <template slot="isprint" slot-scope="params">
        <el-button class="printbtn" :type="params.params.isprint == 1 ? 'primary' : 'danger'"
          @click="printOne(params.params)" size="mini">
          {{ params.params.isprint == 1 ? '打印' : '已打印' }}
        </el-button>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'570px'" :labelWidth="'110px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import mixin from "./mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'car',
      breadcrumb: [
        { name: "财务管理", path: `/finance/initialPayment` },
        { name: "预支款管理", path: `/finance/initialPayment` },
        { name: "全部打款记录" },
      ],
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.fleet,
          label: '车队',
          placeholder: '',
          options: [],
        },
        {
          label: "车种",
          keyName: "car_type_id",
          type: "select",
          options: [],
        },
        {
          label: "预支款类型",
          keyName: "prepaid_type_id",
          type: "select",
          options: [],
        },
        {
          label: "打款款类型",
          keyName: "type",
          type: "select",
          options: [
            { label: '全部', value: 'money' },
            { label: '司机提成', value: 'commission' },
            { label: '差旅费', value: 'travel_expenses' },
            { label: '其他费用', value: 'other' },
          ],
        },
        {
          ...this.ctrls.license
        },
        {
          label: "打款时间",
          keyName: "repaytime",
          type: "daterange",
        },
        // {
        //   label: "打款金额",
        //   keyName: "settled",
        //   placeholder: "打款金额",
        //   type: "number",
        // },
      ],
    };
  },
  methods: {
    goPaymentRecord() {
      this.$router.push(
        `/finance/initialPaymentRecord`
      );
    },
  },
  mounted() {
    this.getOption();
    this.setQueryParams();
    if (this.$route.query.id) {
      this.showAllRecordBtn = true
    }
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
/deep/ .dialog {
  .el-dialog {
    .modal-scroll {

      .el-scrollbar__wrap {
        overflow-x: hidden;
      }

      .is-horizontal {
        display: none;
      }
    }
  }

  // .el-form {
  //   .el-input {
  //     width: 230px;
  //   }
  // }

  .btns {
    margin: 0;
    text-align: center;
  }
}

/deep/ .el-dialog .btns .mians {
  text-align: center;
}
</style>
